import { FormControl } from '@angular/forms';

export function inputTooLow(min: number) {
  return (control: FormControl) => {
    if (control.value < min) {
      return { inputTooLow: true };
    }

    return null;
  };
}
